/*
 * MY GYM PROFILE
 *
 * A deliberately small, read-only bridge between the gym builder and product
 * pages. It reads the builder's compact browser-local save, then tells a shopper
 * that they are returning to an existing plan. It does NOT say a product fits:
 * that requires the live builder catalog, measured product dimensions, clearances,
 * and placement logic. The CTA therefore takes the exact product into the builder
 * where those checks actually run.
 */
(function () {
  'use strict';

  var KEY = 'ctxGymStudio.last';
  var GOALS = ['general', 'strength', 'muscle', 'cardio', 'commercial'];

  function readPlan() {
    var raw = '';
    try { raw = localStorage.getItem(KEY) || ''; } catch (e) { return null; }
    if (!raw || raw.indexOf('~') < 0) return null;

    var parts = raw.split('~');
    var head = String(parts[0] || '').split('_');
    if (head.length < 4) return null;

    var w = parseInt(head[0], 10);
    var d = parseInt(head[1], 10);
    if (!w || !d) return null;

    var shape = ['rect', 'l', 'two'].indexOf(head[7]) > -1 ? head[7] : 'rect';
    var count = parts[1] ? parts[1].split('-').filter(Boolean).length : 0;
    if (!count) return null;

    return {
      w: w,
      d: d,
      shape: shape,
      goal: GOALS[parseInt(head[3], 10)] || 'general',
      count: count
    };
  }

  function shapeLabel(shape) {
    if (shape === 'l') return 'L-shaped room';
    if (shape === 'two') return 'two connected rooms';
    return 'rectangular room';
  }

  function goalLabel(goal) {
    return {
      strength: 'strength-focused',
      muscle: 'muscle-building',
      cardio: 'cardio-focused',
      commercial: 'commercial',
      general: 'general fitness'
    }[goal] || 'general fitness';
  }

  function render() {
    var plan = readPlan();
    var cards = document.querySelectorAll('[data-ctx-my-gym-profile]');
    var ctas = document.querySelectorAll('[data-ctx-my-gym-cta]');

    Array.prototype.forEach.call(cards, function (card) {
      var summary = card.querySelector('[data-ctx-my-gym-summary]');
      if (!plan) {
        card.hidden = true;
        return;
      }
      if (summary) {
        summary.textContent = Math.round(plan.w / 12) + ' ft × ' + Math.round(plan.d / 12) +
          ' ft ' + shapeLabel(plan.shape) + ' · ' + plan.count + ' planned ' +
          (plan.count === 1 ? 'piece' : 'pieces') + ' · ' + goalLabel(plan.goal);
      }
      card.hidden = false;
    });

    Array.prototype.forEach.call(ctas, function (cta) {
      var label = cta.querySelector('[data-ctx-my-gym-label]');
      var sub = cta.querySelector('[data-ctx-my-gym-sub]');
      if (!plan) return;
      if (label) label.textContent = 'Add this to your saved gym';
      if (sub) sub.textContent = 'Open your plan, place it to scale, and review the result';
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render);
  else render();

  /* The builder lives on a different page, but this keeps the profile accurate
     when a customer returns to an already-open PDP tab after changing the plan. */
  window.addEventListener('storage', function (event) {
    if (event.key === KEY) render();
  });
}());
